export const analyzeThesisStrength = (text: string) => {
  if (!text) {
    return {
      readabilityLabel: "Add content",
      structureScore: 0,
      clarityNotes: "Start with a claim, stance, or insight",
    };
  }

  const length = text.trim().split(/\s+/).length;
  const hasBecause = /\b(because|since|as a result)\b/i.test(text);
  const hasContrast = /although|however|yet/i.test(text);
  const readabilityLabel = length < 12 ? "Too short" : length > 60 ? "Too long" : "Focused";
  const structureScore = Math.min(5, [length > 10, hasBecause, hasContrast].filter(Boolean).length + 2);
  const clarityNotes = hasBecause
    ? "Good causal signal. Consider tightening any long phrases."
    : "Add reasons with `because` or `due to` to strengthen the logic chain.";

  return { readabilityLabel, structureScore, clarityNotes };
};
